import { render, staticRenderFns } from "./help-assistant-panel.vue?vue&type=template&id=df7ac438&scoped=true"
import script from "./help-assistant-panel.vue?vue&type=script&lang=js"
export * from "./help-assistant-panel.vue?vue&type=script&lang=js"
import style0 from "./help-assistant-panel.vue?vue&type=style&index=0&id=df7ac438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7ac438",
  null
  
)

export default component.exports